import { ServiceData } from '@goodrx/heydoctor-sdk/es/models/service';
import { styled, Button } from '@goodrx/matisse';
import { PageHeading } from 'app/components/PageHeading';
import { Divider } from 'app/components/core';
import { useOnboardingValidation } from 'app/components/auth/Onboarding/hooks';
import * as Analytics from 'app/lib/analytics';
import { CtaContainer } from 'app/components/auth/SignUp/CtaContainer';
import { SignInCta } from 'app/components/auth/SignUp/SignInCta';
import { AuthLayout } from 'app/components/auth/AuthLayout';
import { HeadingWrapper } from 'app/components/auth/SignUp/HeadingWrapper';
import { CdnImage } from 'app/components/CdnImage';
import { DateOfBirth, Gender } from 'app/components/auth/Onboarding';
import React from 'react';

interface EligibilityProps {
  nextStep: () => void;
  service: ServiceData;
  optimizelyRemoveDob?: boolean;
}

const StyledPageHeading = styled(PageHeading)`
  p {
    font-weight: 500;
  }
`;

const StyledDivider = styled(Divider)<{ marginBottom: number }>`
  margin-top: 24px;
  margin-bottom: ${(p) => (Number.isInteger(p.marginBottom) ? `${p.marginBottom}px` : '24px')};
`;

export const Eligibility = ({ nextStep, service, optimizelyRemoveDob }: EligibilityProps) => {
  const { isValidDateOfBirth, isValidGender } = useOnboardingValidation();

  function handleContinue() {
    nextStep();
    Analytics.trackEvent('Registration CTA Clicked', { buttonName: 'Continue', page: 'Eligibility' });
  }

  return (
    <>
      <CtaContainer>
        <SignInCta small />
      </CtaContainer>
      <AuthLayout>
        <HeadingWrapper>
          <CdnImage src="/images/illustrations/eligibility.svg" alt="eligibility-illustration" />
          <StyledPageHeading
            title="Treatment Eligibility"
            subtitle="Let’s confirm that you’re eligible for this service."
            color="greyDarkest"
            mb={0}
          />
        </HeadingWrapper>
        <StyledDivider />

        {!optimizelyRemoveDob && <DateOfBirth service={service} />}

        <Gender service={service} />
        <StyledDivider marginBottom={0} />
        <Button
          variant="primary"
          size="lg"
          block
          my={4}
          onClick={handleContinue}
          disabled={(!isValidDateOfBirth && !optimizelyRemoveDob) || !isValidGender}>
          Continue
        </Button>
      </AuthLayout>
    </>
  );
};
